export function normalizeSector(raw = "") {
    const cleaned = (raw || "")
      .normalize("NFKC")
      .replace(/[\u00AD\u200B-\u200D\u2060\uFEFF]/g, "")
      .replace(/\s+/g, " ")
      .trim();
  
    const s = cleaned.toLocaleLowerCase("tr");
    const has = (k) => s.includes(k);
  
    if ((has("çanta") || has("canta")) && has("kılıf")) return "Çanta Kılıfı";
    if ((has("çanta") || has("canta")) && has("promosyon")) return "Promosyon Çanta";
    if (has("kılıf") || has("kilif")) return "Kılıf";
    if (has("abiye")) return "Abiye";
    if (has("elbise")) return "Elbise";
    if (has("promosyon")) return "Promosyon";
    if (has("medikal")) return "Medikal";
    if (has("elektronik")) return "Elektronik";
    if (has("bilgisayar")) return "Bilgisayar";
    if (has("fotoğraf") || has("fotograf")) return "Fotoğrafçı";
    if (has("emlak")) return "Emlak";
    if (has("beyaz eşya") || has("beyaz esya")) return "Beyaz Eşya";
    if (has("makina") || has("makine")) return "Makina";
  
    const capTR = (w) => w.charAt(0).toLocaleUpperCase("tr") + w.slice(1);
    const short = s
      .split(/[^\p{L}\p{N}]+/u)
      .filter(Boolean)
      .slice(0, 2)
      .map(capTR)
      .join(" ");
  
    return short || cleaned;
  }
  